export default __webpack_public_path__ + "static/media/KOD0002-min.c393413e.webp";